<app-dialog [title]="data.title" (close)="close()">
    <ng-container dialogHeader>
        <panel-tools
            [showLangButton]="true"
            [showRequiredLabel]="true"
            [isPanelToolsDialog]="true"
            (setCurrentLangForm)="langService.currentLanguage = $event.lang"
        >
        </panel-tools>
    </ng-container>
    <ng-container dialogContent>
        <div #formRef [formGroup]="form" (keydown.enter)="onEnterKey($event)">
            <div class="mb-2">
                <ng-container *ngFor="let lang of langService.languageNames; count as count">
                    <div [class.!hidden]="lang !== (langService.currentLanguage$ | async)">
                        <fui-text-input
                            #langField
                            [fieldGroup]="form.get('name')"
                            [fieldName]="lang"
                            [label]="dictionary.system_name + (count > 1 ? ' (' + lang + ')' : '')"
                            [maxLength]="255"
                            [validationErrorService]="validationErrorService"
                            [forceDisabled]="!data.access.edit"
                        ></fui-text-input>
                    </div>
                </ng-container>
            </div>
            <div class="mb-2">
                <ng-container *ngFor="let lang of langService.languageNames; count as count">
                    <div [class.!hidden]="lang !== (langService.currentLanguage$ | async)">
                        <fui-text-area
                            #langField
                            [fieldGroup]="form.get('full_name')"
                            [fieldName]="lang"
                            [label]="dictionary.rubric_full_name + (count > 1 ? ' (' + lang + ')' : '')"
                            [forceDisabled]="!data.access.edit"
                        ></fui-text-area>
                    </div>
                </ng-container>
            </div>
        </div>
    </ng-container>
    <ng-container dialogActions>
        <ng-container *ngIf="!!data.access.edit">
            <fui-button
                [label]="dictionary.system_save"
                [color]="'primary'"
                [height]="'mini'"
                [icon]="'content-save'"
                (clickEvent)="save()"
            >
            </fui-button>
        </ng-container>
        <fui-button
            [label]="dictionary.system_cancel"
            [color]="'light'"
            [height]="'mini'"
            [icon]="'close'"
            (clickEvent)="close()"
        >
        </fui-button>
    </ng-container>
</app-dialog>
